export default class TimePrinter {
    constructor($filter) {
        this._filter = $filter;
    }

    unitToSpoken(numberOfUnits, unit) {
        if (numberOfUnits == Number.MAX_SAFE_INTEGER) {
            return null;
        }

        var delay = moment.duration(parseInt(numberOfUnits), unit);
        var months = delay.months();
        var days = delay.days();
        var hours = delay.hours();
        var minutes = delay.minutes();
        var numSeconds = delay.seconds();
        var relativeDateString = "";
        var suffix;

        if (months > 0) {
            suffix = months == 1 ? this._filter('translate')('TIME:MONTH') : this._filter('translate')('TIME:MONTHS');
            relativeDateString += months + " " + suffix;
        }

        if (days > 0) {
            suffix = days == 1 ? this._filter('translate')('TIME:DAY') : this._filter('translate')('TIME:DAYS');
            relativeDateString += " " + days + " " + suffix;
        }

        if (hours > 0) {
            suffix = hours == 1 ? this._filter('translate')('TIME:HOUR') : this._filter('translate')('TIME:HOURS');
            relativeDateString += " " + hours + " " + suffix;
        }

        if (minutes > 0) {
            suffix = minutes == 1 ? this._filter('translate')('TIME:MINUTE') : this._filter('translate')('TIME:MINUTES');
            relativeDateString += " " + minutes + " " + suffix;
        }

        if (numSeconds > 0) {
            suffix = numSeconds == 1 ? this._filter('translate')('TIME:SECOND') : this._filter('translate')('TIME:SECONDS');
            relativeDateString += " " + numSeconds + " " + suffix;
        }

        return relativeDateString;
    };

    getTimeUnitAndCount(numberOfUnits, unit) {
        var delay = moment.duration(parseInt(numberOfUnits), unit);
        var days = delay.asDays();
        var hours = delay.asHours();
        var minutes = delay.asMinutes();
        var numSeconds = delay.asSeconds();

        if (days > 0 && Number.isInteger(days)) {
            return { unit: 'days', numUnits: days };
        } else if (hours > 0 && Number.isInteger(hours)) {
            return { unit: 'hours', numUnits: hours };
        } else if (minutes > 0 && Number.isInteger(minutes)) {
            return { unit: 'minutes', numUnits: minutes };
        } else if (numSeconds > 0) {
            return { unit: 'seconds', numUnits: numSeconds };
        } else {
            if (numberOfUnits > 0) {
                // If not even with any time unit, just use the seconds.
                return { unit: 'seconds', numUnits: numberOfUnits };
            } else {
                return { unit: 'hours', numUnits: 0 };
            }
        }
    };
}